export default "__VITE_ASSET__DgB$QUcl__"